// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Coy without shadows
 * Based on Tim Shedor's Coy theme for prism.js
 * Author: RunDevelopment
 */

 code[class*="language-"],
 pre[class*="language-"] {
     color: black;
     background: none;
     font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
     font-size: 1em;
     text-align: left;
     white-space: pre;
     word-spacing: normal;
     word-break: normal;
     word-wrap: normal;
     line-height: 1.5;
     tab-size: 4;
     hyphens: none;
 }
 
 /* Code blocks */
 pre[class*="language-"] {
     position: relative;
     border-left: 10px solid #358ccb;
     box-shadow: -1px 0 0 0 #358ccb, 0 0 0 1px #dfdfdf;
     background-color: #fdfdfd;
     background-image: linear-gradient(transparent 50%, rgba(69, 142, 209, 0.04) 50%);
     background-size: 3em 3em;
     background-origin: content-box;
     background-attachment: local;
     margin: .5em 0;
     padding: 0 1em;
 }
 
 pre[class*="language-"] > code {
     display: block;
 }
 
 /* Inline code */
 :not(pre) > code[class*="language-"] {
     position: relative;
     padding: .2em;
     border-radius: 0.3em;
     color: #c92c2c;
     border: 1px solid rgba(0, 0, 0, 0.1);
     display: inline;
     white-space: normal;
     background-color: #fdfdfd;
     box-sizing: border-box;
 }
 
 .token.comment,
 .token.block-comment,
 .token.prolog,
 .token.doctype,
 .token.cdata {
     color: #7D8B99;
 }
 
 .token.punctuation {
     color: #5F6364;
 }
 
 .token.property,
 .token.tag,
 .token.boolean,
 .token.number,
 .token.function-name,
 .token.constant,
 .token.symbol,
 .token.deleted {
     color: #c92c2c;
 }
 
 .token.selector,
 .token.attr-name,
 .token.string,
 .token.char,
 .token.function,
 .token.builtin,
 .token.inserted {
     color: #2f9c0a;
 }
 
 .token.operator,
 .token.entity,
 .token.url,
 .token.variable {
     color: #a67f59;
     background: rgba(255, 255, 255, 0.5);
 }
 
 .token.atrule,
 .token.attr-value,
 .token.keyword,
 .token.class-name {
     color: #1990b8;
 }
 
 .token.regex,
 .token.important {
     color: #e90;
 }
 
 .language-css .token.string,
 .style .token.string {
     color: #a67f59;
     background: rgba(255, 255, 255, 0.5);
 }
 
 .token.important {
     font-weight: normal;
 }
 
 .token.bold {
     font-weight: bold;
 }
 
 .token.italic {
     font-style: italic;
 }
 
 .token.entity {
     cursor: help;
 }
 
 .token.namespace {
     opacity: .7;
 }`, "",{"version":3,"sources":["webpack://./src/theme/coy-without-shadows.css"],"names":[],"mappings":"AAAA;;;;EAIE;;CAED;;KAEI,YAAY;KACZ,gBAAgB;KAChB,sEAAsE;KACtE,cAAc;KACd,gBAAgB;KAChB,gBAAgB;KAChB,oBAAoB;KACpB,kBAAkB;KAClB,iBAAiB;KACjB,gBAAgB;KAIhB,WAAW;KAKX,aAAa;CACjB;;CAEA,gBAAgB;CAChB;KACI,kBAAkB;KAClB,+BAA+B;KAC/B,iDAAiD;KACjD,yBAAyB;KACzB,gFAAgF;KAChF,wBAAwB;KACxB,8BAA8B;KAC9B,4BAA4B;KAC5B,cAAc;KACd,cAAc;CAClB;;CAEA;KACI,cAAc;CAClB;;CAEA,gBAAgB;CAChB;KACI,kBAAkB;KAClB,aAAa;KACb,oBAAoB;KACpB,cAAc;KACd,oCAAoC;KACpC,eAAe;KACf,mBAAmB;KACnB,yBAAyB;KAGzB,sBAAsB;CAC1B;;CAEA;;;;;KAKI,cAAc;CAClB;;CAEA;KACI,cAAc;CAClB;;CAEA;;;;;;;;KAQI,cAAc;CAClB;;CAEA;;;;;;;KAOI,cAAc;CAClB;;CAEA;;;;KAII,cAAc;KACd,oCAAoC;CACxC;;CAEA;;;;KAII,cAAc;CAClB;;CAEA;;KAEI,WAAW;CACf;;CAEA;;KAEI,cAAc;KACd,oCAAoC;CACxC;;CAEA;KACI,mBAAmB;CACvB;;CAEA;KACI,iBAAiB;CACrB;;CAEA;KACI,kBAAkB;CACtB;;CAEA;KACI,YAAY;CAChB;;CAEA;KACI,WAAW;CACf","sourcesContent":["/**\n * Coy without shadows\n * Based on Tim Shedor's Coy theme for prism.js\n * Author: RunDevelopment\n */\n\n code[class*=\"language-\"],\n pre[class*=\"language-\"] {\n     color: black;\n     background: none;\n     font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;\n     font-size: 1em;\n     text-align: left;\n     white-space: pre;\n     word-spacing: normal;\n     word-break: normal;\n     word-wrap: normal;\n     line-height: 1.5;\n \n     -moz-tab-size: 4;\n     -o-tab-size: 4;\n     tab-size: 4;\n \n     -webkit-hyphens: none;\n     -moz-hyphens: none;\n     -ms-hyphens: none;\n     hyphens: none;\n }\n \n /* Code blocks */\n pre[class*=\"language-\"] {\n     position: relative;\n     border-left: 10px solid #358ccb;\n     box-shadow: -1px 0 0 0 #358ccb, 0 0 0 1px #dfdfdf;\n     background-color: #fdfdfd;\n     background-image: linear-gradient(transparent 50%, rgba(69, 142, 209, 0.04) 50%);\n     background-size: 3em 3em;\n     background-origin: content-box;\n     background-attachment: local;\n     margin: .5em 0;\n     padding: 0 1em;\n }\n \n pre[class*=\"language-\"] > code {\n     display: block;\n }\n \n /* Inline code */\n :not(pre) > code[class*=\"language-\"] {\n     position: relative;\n     padding: .2em;\n     border-radius: 0.3em;\n     color: #c92c2c;\n     border: 1px solid rgba(0, 0, 0, 0.1);\n     display: inline;\n     white-space: normal;\n     background-color: #fdfdfd;\n     -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n     box-sizing: border-box;\n }\n \n .token.comment,\n .token.block-comment,\n .token.prolog,\n .token.doctype,\n .token.cdata {\n     color: #7D8B99;\n }\n \n .token.punctuation {\n     color: #5F6364;\n }\n \n .token.property,\n .token.tag,\n .token.boolean,\n .token.number,\n .token.function-name,\n .token.constant,\n .token.symbol,\n .token.deleted {\n     color: #c92c2c;\n }\n \n .token.selector,\n .token.attr-name,\n .token.string,\n .token.char,\n .token.function,\n .token.builtin,\n .token.inserted {\n     color: #2f9c0a;\n }\n \n .token.operator,\n .token.entity,\n .token.url,\n .token.variable {\n     color: #a67f59;\n     background: rgba(255, 255, 255, 0.5);\n }\n \n .token.atrule,\n .token.attr-value,\n .token.keyword,\n .token.class-name {\n     color: #1990b8;\n }\n \n .token.regex,\n .token.important {\n     color: #e90;\n }\n \n .language-css .token.string,\n .style .token.string {\n     color: #a67f59;\n     background: rgba(255, 255, 255, 0.5);\n }\n \n .token.important {\n     font-weight: normal;\n }\n \n .token.bold {\n     font-weight: bold;\n }\n \n .token.italic {\n     font-style: italic;\n }\n \n .token.entity {\n     cursor: help;\n }\n \n .token.namespace {\n     opacity: .7;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
